import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: process.env.FIREBASE_KEY,
  authDomain: "lupo-pizzeria-52bb8.firebaseapp.com",
  projectId: "lupo-pizzeria-52bb8",
  storageBucket: "lupo-pizzeria-52bb8.firebasestorage.app",
  messagingSenderId: "60011786783",
  appId: "1:60011786783:web:3e62a6b19cebe48e77db2a",
  measurementId: "G-ET7E3CH3PH"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export default analytics;